import { useState, useEffect } from "react";
import { Box, Button, Typography, Slide, Paper } from "@mui/material";
import { useConsent } from "@/hooks/useConsent";
import { color } from "@/theme/tokens";

export function CookieBanner() {
	const [mounted, setMounted] = useState(false);
	const { hasResponded, acceptAll, rejectAll } = useConsent();

	useEffect(() => {
		setMounted(true);
	}, []);

	if (!mounted || hasResponded) return null;

	return (
		<Slide direction="up" in={!hasResponded} mountOnEnter unmountOnExit>
			<Paper
				elevation={8}
				sx={{
					position: "fixed",
					bottom: 0,
					left: 0,
					right: 0,
					zIndex: 9999,
					backgroundColor: "rgba(23, 23, 23, 0.95)",
					backdropFilter: "blur(10px)",
					borderTop: "1px solid rgba(255, 255, 255, 0.1)",
					p: 2,
				}}
			>
				<Box
					sx={{
						maxWidth: "1200px",
						mx: "auto",
						display: "flex",
						flexDirection: { xs: "column", md: "row" },
						alignItems: { xs: "flex-start", md: "center" },
						gap: 2,
					}}
				>
					<Box sx={{ flex: 1 }}>
						<Typography variant="body2" sx={{ color: "rgba(255, 255, 255, 0.8)" }}>
							This website uses cookies to enhance your experience.
						</Typography>
					</Box>

					<Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
						<Button
							variant="outlined"
							size="small"
							onClick={rejectAll}
							sx={{
								color: "rgba(255, 255, 255, 0.8)",
								borderColor: "rgba(255, 255, 255, 0.3)",
							}}
						>
							Decline
						</Button>

						<Button
							variant="contained"
							size="small"
							onClick={acceptAll}
							sx={{
								backgroundColor: color.violet,
								"&:hover": {
									backgroundColor: color.violet700,
								},
							}}
						>
							Accept
						</Button>
					</Box>
				</Box>
			</Paper>
		</Slide>
	);
}
